// extracted by mini-css-extract-plugin
export var modal = "_t1-0";
export var table = "_t1-1";